import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useBag } from "@/context/BagContext";
import { COLOR_META, COLLECTION_META, formatPrice } from "@/lib/meta";
import Placeholder from "./Placeholder";
import { motion } from "framer-motion";

export default function ProductCard({ product, index = 0 }) {
  const { t, lang } = useLang();
  const { add } = useBag();
  const price = formatPrice(product.price);

  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
    >
      <div className="relative">
        <Link to={`/piece/${product.slug}`} data-testid={`product-card-${product.slug}`} className="block">
          <Placeholder
            variant={product.gradient}
            aspect="aspect-[3/4]"
            className="rounded-[1.2rem] sm:rounded-[1.6rem] transition-transform duration-700 group-hover:scale-[1.012]"
          />
          {product.tag && (
            <span className="absolute top-3 start-3 z-20 bg-rose text-ivory text-[10px] uppercase tracking-[0.14em] px-2.5 py-1 rounded-full">
              {product.tag === "new" ? t.common.new : t.common.signature}
            </span>
          )}
        </Link>
        <button
          data-testid={`quick-add-${product.slug}`}
          onClick={() => add(product, product.sizes[0], product.colors[0])}
          className="absolute bottom-3 end-3 z-20 opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-ivory/90 backdrop-blur text-ink text-[10px] uppercase tracking-[0.12em] px-3.5 py-2 rounded-full hover:bg-ink hover:text-ivory"
        >
          + {t.common.addToBag}
        </button>
      </div>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div>
          <Link to={`/piece/${product.slug}`} className="font-serif text-[17px] leading-snug hover:text-rose-deep transition-colors">
            {product.name[lang]}
          </Link>
          <p className="text-[12px] text-ink/50 mt-0.5">{COLLECTION_META[product.collection]?.[lang]}</p>
        </div>
        <p className="text-[14px] text-ink/80 whitespace-nowrap pt-0.5">{price}</p>
      </div>
    </motion.div>
  );
}
